import { runbookSystemService } from "../services/runbookSystem.service";
import { runbookSystemConstants } from "../constants/runbookSystem.constants";

export const runbookSystemActions = {
  getAll,
  get,
  getById,
  create,
  update,
  remove,
};

function getAll() {
  return (dispatch) => {
    dispatch(request());

    runbookSystemService.getAll().then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: runbookSystemConstants.GET_ALL_REQUEST,
    };
  }
  function success(result) {
    return { type: runbookSystemConstants.GET_ALL_SUCCESS, payload: result };
  }
  function failure() {
    return { type: runbookSystemConstants.GET_ALL_FAILURE };
  }
}

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookSystemService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookSystemConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: runbookSystemConstants.GET_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: runbookSystemConstants.GET_FAILURE };
  }
}

function getById(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookSystemService.getById(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookSystemConstants.GET_BY_ID_REQUEST,
      payload: requestParameters,
    };
  }
  function success(system) {
    return {
      type: runbookSystemConstants.GET_BY_ID_SUCCESS,
      payload: system,
    };
  }
  function failure() {
    return {
      type: runbookSystemConstants.GET_BY_ID_FAILURE,
    };
  }
}

function create(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookSystemService.create(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookSystemConstants.CREATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: runbookSystemConstants.CREATE_SUCCESS };
  }
  function failure(error) {
    return { type: runbookSystemConstants.CREATE_FAILURE, payload: error };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookSystemService.update(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookSystemConstants.UPDATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: runbookSystemConstants.UPDATE_SUCCESS };
  }
  function failure(error) {
    return { type: runbookSystemConstants.UPDATE_FAILURE, payload: error };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookSystemService.remove(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: runbookSystemConstants.DELETE_REQUEST,
    };
  }
  function success() {
    return { type: runbookSystemConstants.DELETE_SUCCESS };
  }
  function failure() {
    return { type: runbookSystemConstants.DELETE_FAILURE };
  }
}
